export default "__VITE_ASSET__CZaTtJHp__"